import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";

const AddPackagePeriod = ({ show, onClose, onSuccess }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    // const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const toTitleCase = (str) =>
        str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());

    const [form, setForm] = useState({
        packagetimeline_name: '',
        score: '',
        days: '',
        description: '',
        all_days: true, 
        specification: false,
        sunday: false, 
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === 'packagetimeline_name') {
            updatedValue = toTitleCase(value).slice(0, 50);
        } else if (name === 'score') {
            updatedValue = value.replace(/\D/g, '').slice(0, 2);
        } else if (name === 'days') {
            updatedValue = value.replace(/\D/g, '').slice(0, 4);
        }

        setForm({ ...form, [name]: updatedValue });
        setErrors({ ...errors, [name]: '' });
    };

    const handleCheckbox = (e) => {
        const { name, checked } = e.target;
        setForm({ ...form, [name]: checked });
    };

    const handleRadio = (type) => {
        setForm({
            ...form,
            all_days: type === 'alldays',
            specification: type === 'specification'
        });
    };

    const handleSubmit = () => {
        const newErrors = {};

        if (!form.packagetimeline_name.trim()) {
            newErrors.packagetimeline_name = "This field is required.";
        }

        if (!form.score || isNaN(form.score) || parseInt(form.score) <= 0) {
            newErrors.score = "Enter a valid number of score.";
        }

        if (!form.days || isNaN(form.days) || parseInt(form.days) <= 0) {
            newErrors.days = "Enter a valid number of days.";
        }

        if (form.specification) {
            const hasSelectedDay = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
                .some(day => form[day]);
            if (!hasSelectedDay) {
                newErrors.specificationDays = "Please select at least one day.";
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
        const user_id = parseInt(localStorage.getItem("user_id"), 10);

        const payload = {
            packagetimeline_name: form.packagetimeline_name.trim(),
            score: form.score,
            days: form.days,
            description: form.description.trim(),
            all_days: form.all_days ? 0 : 1,
            specification: form.specification ? 0 : 1
        };

        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

        if (form.all_days) {
            days.forEach(day => {
                payload[day] = 1;
            });
        } else if (form.specification) {
            days.forEach(day => {
                payload[day] = form[day] ? 0 : 1;
            });
        }

        if (!isNaN(branch_id)) {
        payload.branch_id = branch_id;
        }
        if (!isNaN(user_id)) {
        payload.created_by = user_id;
        }

        axios.post(`${baseURL}/package-timeline`, payload)
            .then(() => {
                onClose();
                if (onSuccess) onSuccess();
            })
            .catch(err => {
                if (err.response?.data?.errors) {
                    const backendErrors = err.response.data.errors;
                    const formattedErrors = {};
                    Object.keys(backendErrors).forEach(field => {
                        formattedErrors[field] = backendErrors[field][0];
                    });
                    setErrors(formattedErrors);
                } else {
                    alert('Something went wrong while creating the timeline.');
                }
                console.error('API error:', err);
            });
    };

    return (
        <Modal className="modal fade" show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Package Timeline</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Package Timeline<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Package Timeline"
                                name="packagetimeline_name"
                                value={form.packagetimeline_name}
                                onChange={handleChange}
                                maxLength={50}
                            />
                            {errors.packagetimeline_name && (
                                <span className="text-danger">{errors.packagetimeline_name}</span>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Score<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Score"
                                name="score"
                                maxLength={2}
                                value={form.score}
                                onChange={handleChange}
                            />
                            {errors.score && (
                                <span className="text-danger">{errors.score}</span>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                No Of Days<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter No Of Days"
                                name="days"
                                maxLength={4}
                                value={form.days}
                                onChange={handleChange}
                            />
                            {errors.days && (
                                <span className="text-danger">{errors.days}</span>
                            )}
                        </div>

                        <div className="col-lg-12">
                            <div className='mb-4 mt-2'>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="days_type"
                                        checked={form.all_days}
                                        onChange={() => handleRadio('alldays')}
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">
                                        All Days
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="days_type"
                                        checked={form.specification}
                                        onChange={() => handleRadio('specification')}
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">
                                        Specification
                                    </label>
                                </div>

                                {form.specification && (
                                    <div className='row mt-2'>
                                        {['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map(day => (
                                            <div key={day} className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name={day}
                                                    checked={form[day]}
                                                    onChange={handleCheckbox}
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    {day.charAt(0).toUpperCase() + day.slice(1)}
                                                </label>
                                            </div>
                                        ))}
                                        {errors.specificationDays && (
                                            <div className="col-12">
                                                <span className="text-danger">{errors.specificationDays}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Create Package Timeline <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddPackagePeriod;
